import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../feedback/ConfirmDialog";

const ConfirmDeleteSpecSheet = ({
  show,
  onHide,
  confirmDescription,
  confirmButtonText,
  onConfirmClick,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      show={show}
      onHide={onHide}
      description={t(
        confirmDescription || "message.confirm.confirmDeleteSpecSheet",
      )}
      confirmText={t(confirmButtonText || "message.confirm.deleteSpecSheet")}
      onConfirm={onConfirmClick}
    />
  );
};

export default ConfirmDeleteSpecSheet;
